<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="createSubMenu" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{ ++index }}</td>
              <td>
                {{ item.menu && item.menu.branch ? item.menu.branch.branch_name_th : "" }}
              </td>
              <td>
                {{ item.service ? item.service.title_th : "" }}
              </td>
              <td>
                {{ item.menu ? item.menu.title_th : "" }}
              </td>
              <td>{{ item.title_th }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>
                <a @click="showSubMenuData(item.sub_menu_id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </div>
</template>

<script>
import InputSearch from "../../../components/Input/InputSearch";
import CircleButton from "../../../components/Button/CircleButton";
import IconPencil from "../../../components/Icon/icon-pencil";
export default {
  name: "MenuTable",
  components: { IconPencil, CircleButton, InputSearch },
  data() {
    return {
      title: "Sub menu",
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Branch" },
        { id: 3, text: "Service" },
        { id: 4, text: "Menu" },
        { id: 5, text: "Sub Menu" },
        { id: 6, text: "Update date" },
        { id: 7, text: "edit" }
      ],
      dataTable: []
    };
  },
  created() {
    this.getSubMenuTable(1);
  },
  methods: {
    getSubMenuTable(page) {
      this.$store.dispatch("SubMenu/getSubMenu", page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
        } else {
          alert(res.response_msg);
        }
        console.log(this.dataTable);
      });
    },
    showSubMenuData(id) {
      this.$store.dispatch("SubMenu/showSubMenu", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("SubMenu/setFormSubMenu", res.result).then(() => {
            this.goToSubMenuEdit();
          });
        } else {
          alert(res.response_msg);
        }
      });
    },
    createSubMenu() {
      this.$store.dispatch("SubMenu/clearFormData").then(() => {
        this.goToSubMenuEdit();
      });
    },
    goToSubMenuEdit() {
      this.$router.push("/sub-menu/edit");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/table.css";
@import "../../../assets/css/variables.scss";
.branch-data {
  background-color: $background-theme;
  margin: $margin-search;
}
</style>
